// Central source of truth for all race categories
// Import this everywhere instead of defining categories locally

export const CATEGORIES = [
  'Elite', 'Amateure', 'U23', 'U19', 'U17', 'U15', 'U13', 'U11',
  'Master 1', 'Master 2', 'Master 3', 'Master 4',
  'Elite Frauen', 'U23 Frauen', 'U19 Juniorinnen', 'U17 Juniorinnen', 'U15 Juniorinnen', 'Masters Frauen',
];

export const CAT_STYLE = {
  Elite:    { color: 'var(--brand-primary)', bg: 'rgba(var(--brand-primary-rgb),0.10)',   border: 'rgba(var(--brand-primary-rgb),0.3)' },
  U23:      { color: '#7ecfff', bg: 'rgba(126,207,255,0.10)', border: 'rgba(126,207,255,0.3)' },
  Amateure: { color: 'var(--brand-secondary)', bg: 'rgba(var(--brand-secondary-rgb),0.10)',   border: 'rgba(var(--brand-secondary-rgb),0.3)' },
  'Master 1': { color: '#f4a44a', bg: 'rgba(244,164,74,0.10)',  border: 'rgba(244,164,74,0.3)' },
  'Master 2': { color: '#e8834a', bg: 'rgba(232,131,74,0.10)',  border: 'rgba(232,131,74,0.3)' },
  'Master 3': { color: '#d9614a', bg: 'rgba(217,97,74,0.10)',   border: 'rgba(217,97,74,0.3)' },
  'Master 4': { color: '#c73f3f', bg: 'rgba(199,63,63,0.10)',   border: 'rgba(199,63,63,0.3)' },
  U19:      { color: '#ffb4ab', bg: 'rgba(255,180,171,0.10)', border: 'rgba(255,180,171,0.3)' },
  U17:      { color: '#ffd580', bg: 'rgba(255,213,128,0.10)', border: 'rgba(255,213,128,0.3)' },
  U15:      { color: '#c3a6ff', bg: 'rgba(195,166,255,0.10)', border: 'rgba(195,166,255,0.3)' },
  U13:      { color: '#ff9de2', bg: 'rgba(255,157,226,0.10)', border: 'rgba(255,157,226,0.3)' },
  U11:      { color: '#80ffb4', bg: 'rgba(128,255,180,0.10)', border: 'rgba(128,255,180,0.3)' },
  'Elite Frauen':      { color: '#ff6eb4', bg: 'rgba(255,110,180,0.10)', border: 'rgba(255,110,180,0.3)' },
  'U23 Frauen':        { color: '#ff8fc8', bg: 'rgba(255,143,200,0.10)', border: 'rgba(255,143,200,0.3)' },
  'U19 Juniorinnen':   { color: '#ffadd8', bg: 'rgba(255,173,216,0.10)', border: 'rgba(255,173,216,0.3)' },
  'U17 Juniorinnen':   { color: '#ffc4e3', bg: 'rgba(255,196,227,0.10)', border: 'rgba(255,196,227,0.3)' },
  'U15 Juniorinnen':   { color: '#ffd6ec', bg: 'rgba(255,214,236,0.10)', border: 'rgba(255,214,236,0.3)' },
  'Masters Frauen':    { color: '#e86fa8', bg: 'rgba(232,111,168,0.10)', border: 'rgba(232,111,168,0.3)' },
};

export const CAT_DESC = {
  Elite:      'Die höchste nationale Amateurklasse. Hier fahren sehr erfahrene und leistungsorientierte Amateure.',
  U23:        'Nachwuchsklasse für Fahrer unter 23 Jahren.',
  Amateure:   'Der ideale Einstieg für neue Lizenzfahrer. Hier messen sich ambitionierte Amateure und Neueinsteiger.',
  'Master 1': 'Senioren ab 30 Jahren.',
  'Master 2': 'Senioren ab 40 Jahren.',
  'Master 3': 'Senioren ab 50 Jahren.',
  'Master 4': 'Senioren ab 60 Jahren.',
  U19:        'Nachwuchsklasse für Fahrer unter 19 Jahren.',
  U17:        'Jugendklasse für Fahrer unter 17 Jahren.',
  U15:        'Jugendklasse für Fahrer unter 15 Jahren.',
  U13:        'Schülerklasse für Fahrer unter 13 Jahren.',
  U11:        'Schülerklasse für Fahrer unter 11 Jahren.',
  'Elite Frauen':    'Die höchste Klasse für Fahrerinnen. Erfahrene und leistungsorientierte Amateurfahrerinnen.',
  'U23 Frauen':      'Nachwuchsklasse für Fahrerinnen unter 23 Jahren.',
  'U19 Juniorinnen': 'Nachwuchsklasse für Fahrerinnen unter 19 Jahren.',
  'U17 Juniorinnen': 'Jugendklasse für Fahrerinnen unter 17 Jahren.',
  'U15 Juniorinnen': 'Jugendklasse für Fahrerinnen unter 15 Jahren.',
  'Masters Frauen':  'Seniorinnen ab 30 Jahren.',
};

// Fallback for unknown categories
export const getCatStyle = (cat) => CAT_STYLE[cat] || CAT_STYLE.Elite;

// Categories split by gender
export const MALE_CATEGORIES = [
  'Elite', 'Amateure', 'U23', 'U19', 'U17', 'U15', 'U13', 'U11',
  'Master 1', 'Master 2', 'Master 3', 'Master 4',
];

export const FEMALE_CATEGORIES = [
  'Elite Frauen', 'U23 Frauen', 'U19 Juniorinnen', 'U17 Juniorinnen', 'U15 Juniorinnen', 'Masters Frauen',
];

// Returns the right category list based on gender value ('männlich' | 'weiblich' | null)
export const getCategoriesForGender = (gender) => {
  if (gender === 'weiblich') return FEMALE_CATEGORIES;
  if (gender === 'männlich') return MALE_CATEGORIES;
  return CATEGORIES; // show all if no gender set
};
